const SET_DATA_STATISTIC_REQUEST = 'SET_DATA_STATISTIC_REQUEST';
const SET_DATA_STATISTIC_SUCCESS = 'SET_DATA_STATISTIC_SUCCESS';
const SET_DATA_STATISTIC_FAILUER = 'SET_DATA_STATISTIC_FAILUER';

const CHANGE_VALUE = 'CHANGE_VALUE';

const initialState = {
  loading: false,
  success: false,
  failure: false,
  data: {
    allCastings: null,
    allCompanies: null,
    applicants: null,
    freelancers: null,
    moderatedCastings: null,
    moderatedCompanies: null,
    recruiters: null,
    representatives: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA_STATISTIC_REQUEST:
      return {
        loading: true,
        success: false,
        failure: false,
        data: {
          allCastings: null,
          allCompanies: null,
          applicants: null,
          freelancers: null,
          moderatedCastings: null,
          moderatedCompanies: null,
          recruiters: null,
          representatives: null,
        },
      };
    case SET_DATA_STATISTIC_SUCCESS:
      return {
        loading: false,
        success: true,
        failure: false,
        data: action.payload,
      };
    case SET_DATA_STATISTIC_FAILUER:
      return {
        loading: false,
        success: false,
        failure: true,
        data: {
          allCastings: null,
          allCompanies: null,
          applicants: null,
          freelancers: null,
          moderatedCastings: null,
          moderatedCompanies: null,
          recruiters: null,
          representatives: null,
        },
      };
    case CHANGE_VALUE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const setDataStatisticRequest = () => ({
  type: SET_DATA_STATISTIC_REQUEST,
});

export const setDataStatisticSuccess = (payload) => ({
  type: SET_DATA_STATISTIC_SUCCESS,
  payload,
});

export const setDataStatisticFailure = () => ({
  type: SET_DATA_STATISTIC_FAILUER,
});

export const changeValue = (payload) => ({
  type: CHANGE_VALUE,
  payload,
});
